import { Component } from 'opus-angular-seed-core';
import template from './template.html';

@Component({
    bindings: {
        disabled: '<',
        question: '=',
        form: '=',
        haswell: '=',
        scale: '=',
        matrix: '=',
        scaleSteps: '=',
        models: '=',
        formType: '=',
        chosenFiles: '=',
        chosenVideoFiles: '='
    },
    template
})

export default class {
    constructor (lodash, $scope, $translate,
                 TokenService, QuestionFormService, ModalService,
                 QUESTIONS_TYPE_ENUM, FORMS_QUESTION_TYPE_ENUM, FORMS_TYPE_ENUM,
                 QUESTIONS_ANSWER_CORRECTNESS_TYPE_ENUM) {
        this.lodash = lodash;
        this.$scope = $scope;
        this.$translate = $translate;
        this.TokenService = TokenService;
        this.QuestionFormService = QuestionFormService;
        this.ModalService = ModalService;
        this.QUESTIONS_TYPE_ENUM = QUESTIONS_TYPE_ENUM;
        this.FORMS_QUESTION_TYPE_ENUM = FORMS_QUESTION_TYPE_ENUM;
        this.FORMS_TYPE_ENUM = FORMS_TYPE_ENUM;
        this.QUESTIONS_ANSWER_CORRECTNESS_TYPE_ENUM = QUESTIONS_ANSWER_CORRECTNESS_TYPE_ENUM;
    }

    $onInit () {
        if (this.formType) {
            this.formTypes = {};
            this.formTypes[this.formType] = this.FORMS_QUESTION_TYPE_ENUM[this.formType];
            return;
        }
        this.formTypes = this.FORMS_QUESTION_TYPE_ENUM;
    }

    save () {
        const lang = this.TokenService.getCompanyLanguage && this.TokenService.getCompanyLanguage();
        if (lang && this.form && this.form.model && this.form.model.questionAnswers) {
            this.prepareAnswersTranslations(this.form, lang);
        }
        this.normalizeCorrectnessBeforeSubmit();
        this.$scope.$parent.vm.save(false);
    }

    normalizeCorrectnessBeforeSubmit () {
        const qa = (this.form && this.form.model && this.form.model.questionAnswers)
            ? this.form.model.questionAnswers : [];
        for (let i = 0; i < qa.length; i++) {
            const a = qa[i] || {};
            if (!a.correctness) {
                a.correctness = this.QUESTIONS_ANSWER_CORRECTNESS_TYPE_ENUM.INCORRECT;
                a.isCorrect = this.QUESTIONS_ANSWER_CORRECTNESS_TYPE_ENUM.INCORRECT;
                a.isNotApplicable = '';
            }
            if (this.models && this.models.list) {
                if (!this.models.list[i]) this.models.list[i] = {};
                this.models.list[i].correctness = a.correctness;
                this.models.list[i].isCorrect = a.isCorrect;
                this.models.list[i].isNotApplicable = a.isNotApplicable;
            }
        }
    }

    prepareAnswersTranslations (form, defaultLanguage) {
        (form.model.questionAnswers || []).forEach(a => {
            if (!a.translations) a.translations = {};
            if (!a.translations[defaultLanguage]) {
                a.translations[defaultLanguage] = { text: '', feedback: '' };
            }
            if (typeof a.translations[defaultLanguage].text !== 'string') {
                a.translations[defaultLanguage].text = '';
            }
            if (typeof a.translations[defaultLanguage].feedback !== 'string') {
                a.translations[defaultLanguage].feedback = '';
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/questions/actions/answers/index.js